module.exports = __webpack_public_path__ + "img/Colorado2.49a4f0fb.png";